import React, { useState } from 'react';
import cookie from 'js-cookie';
import { connect } from 'react-redux';
import { Modal, Button, Form, Input, message, Checkbox } from 'antd';
import { withRouter, Link } from 'react-router-dom';

import { LoginAccount } from './actions';
import {
  actionGetProfile,
  actionShowLoading,
  actionHideLoading,
} from '../system/actions';
import { getUserAffiliationInfo } from '../dashboard/actions';

import { TOKEN, routes, routePage } from '../../utils/constants/constant';
import './Login.scss';

import ButtonLoginViaGGFB from '../../components/login/ButtonLoginViaGGFB';

const LoginModal = ({
  visible,
  handleVisible = () => {},
  history,
  actionGetProfile,
  actionHideLoading,
  actionShowLoading,
}) => {
  const [isRead, setIsRead] = useState(true);
  const onFinish = async (values) => {
    try {
      actionShowLoading();
      const { data } = await LoginAccount(values);
      if (data.code === 200) {
        getToken(data.data);
      } else {
        data?.message && message.error(data?.message);
        actionHideLoading();
      }
    } catch (error) {
      actionHideLoading();
    }
  };

  const getToken = async (values) => {
    try {
      const { data } = await getUserAffiliationInfo({
        //eslint-disable-next-line
        ['login_token']: `${values.loginToken}`,
      });
      actionHideLoading();
      if (data.code === 200) {
        cookie.set(TOKEN, values.loginToken, { expires: 182 });
        message.success('Đăng nhập thành công!');
        handleVisible('');
        history.push(`${routes.DASHBOARD}`);
        actionGetProfile();
      } else {
        data?.message && message.error(data?.message);
      }
    } catch (error) {
      actionHideLoading();
    }
  };

  const onChange = (e) => {
    setIsRead(e.target.checked);
  };

  const onFinishFailed = (errorInfo) => {};
  return (
    <Modal
      title='Đăng nhập'
      centered
      visible={visible}
      onCancel={handleVisible}
      className='modal-login'
      width={400}
    >
      <ButtonLoginViaGGFB />
      <div className='text-des'>Hoặc đăng nhập bằng số điện thoại, email</div>
      <Form
        colon={false}
        hideRequiredMark
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        className='login-form'
      >
        <Form.Item
          name='account'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập Số điện thoại hoặc Email',
            },
          ]}
        >
          <Input
            placeholder='Nhập Số điện thoại hoặc Email'
            className='input-login'
          />
        </Form.Item>
        <Form.Item
          name='password'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập mật khẩu',
            },
          ]}
        >
          <Input
            type='password'
            placeholder='Mật khẩu'
            className='input-login'
          />
        </Form.Item>
        <Form.Item>
          <Checkbox checked={isRead} onChange={onChange}>
            <span>
              Tôi đã đọc và đồng ý với
              <Link to={routePage.HELP.FAQS_HELP} className='term-policy'>
                điều kiện và điều khoản của chương trình
              </Link>
              trở thành đối tác của Mytour và đồng ý với việc dữ liệu cá nhân
              của tôi được xử lý theo
              <a
                href='https://mytour.vn/news/135152-chinh-sach-va-quy-dinh-chung.html'
                target='_blank'
                rel='noopener noreferrer'
                className='term-policy'
              >
                Chính sách quyền riêng tư
              </a>
              của Mytour.
            </span>
          </Checkbox>
        </Form.Item>
        <Form.Item style={{ marginBottom: '16px' }}>
          <Button
            disabled={!isRead}
            type='primary'
            htmlType='submit'
            className={`btn-login ${!isRead ? 'btn-disable' : ''}`}
          >
            Đăng nhập
          </Button>
        </Form.Item>
      </Form>
      <div className='line-item'>
        <Button
          type='text'
          className='btn-forgot-pw'
          onClick={() => handleVisible('FORGOT_PASSWORD_MODAL')}
        >
          Quên mật khẩu
        </Button>
      </div>
      <div className='line-item register-box'>
        <span>Chưa có tài khoản?</span>
        <Button
          type='text'
          className='btn-forgot-pw btn-link-register'
          onClick={() => handleVisible('REGISTER_MODAL')}
        >
          Đăng ký tài khoản
        </Button>
      </div>
    </Modal>
  );
};

export default connect(
  (state) => ({
    profile: state.systemReducer.profile,
  }),
  {
    actionGetProfile,
    actionShowLoading,
    actionHideLoading,
  }
)(withRouter(LoginModal));
